
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"display-classification-as-circular-chart.title":"Klassifikation als Kreisdiagramm darstellen"},"en":{"display-classification-as-circular-chart.title":"Display classification as pie chart"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();